<template>
    <div class="ks-img-buttons-wrap">
        <div class="ks-img-buttons" v-if="!hideButtons">
            <div>
                <a href="#" data-fancybox :data-src="fullPath">
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M14.039 2.91372L11.3597 5.57451L12.6761 6.891L15.3369 4.21166L17.4693 6.34401V0.781372H11.9066L14.039 2.91372ZM6.34401 0.781372H0.781372V6.34401L2.91372 4.21166L5.57451 6.891L6.891 5.57451L4.21166 2.91372L6.34401 0.781372ZM5.57451 11.3597L2.91372 14.039L0.781372 11.9066V17.4693H6.34401L4.21166 15.3369L6.891 12.6761L5.57451 11.3597ZM12.6761 11.3597L11.3597 12.6761L14.039 15.3369L11.9066 17.4693H17.4693V11.9066L15.3369 14.039L12.6761 11.3597Z"
                            fill="#68AA13"/>
                    </svg>
                </a>
            </div>
            <div>
                <a :href="fullPath" download="rsy_ad">
                    <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                              d="M17.6429 10.8571C18.3924 10.8571 19 11.4648 19 12.2143V16.2857C19 17.7848 17.7848 19 16.2857 19H2.71429C1.21523 19 0 17.7848 0 16.2857V12.2143C0 11.4648 0.60762 10.8571 1.35714 10.8571C2.10667 10.8571 2.71429 11.4647 2.71429 12.2143V16.2857H16.2857V12.2143C16.2857 11.4647 16.8933 10.8571 17.6429 10.8571ZM9.5 0C10.2495 0 10.8571 0.60762 10.8571 1.35714V7.58071L12.6118 5.82607C13.1418 5.29607 14.0011 5.29607 14.5311 5.82607C15.061 6.35607 15.061 7.21536 14.5311 7.74536L9.5 12.7764L4.46892 7.74536C3.93893 7.21536 3.93893 6.35607 4.46892 5.82607C4.99893 5.29607 5.85822 5.29607 6.38822 5.82607L8.14286 7.58071V1.35714C8.14286 0.60762 8.75048 0 9.5 0Z"
                              fill="#68AA13"/>
                    </svg>
                </a>
            </div>
        </div>
        <div>
            <a data-fancybox :data-src="fullPath">
                <img :src="fullPath" class="small-ks-img" alt="">
            </a>
        </div>
    </div>
</template>

<script>
import S3storage from "../../mixins/S3storage";

export default {
    name: "KsImg",
    mixins: [S3storage],
    props: {
        hideButtons: {
            type: Boolean
        },
        imgUrl: {
            type: String,
            required: true,
        }
    },
    computed: {
        fullPath () {
            return this.getImageUrl(this.imgUrl)
        }
    }
}
</script>

<style scoped>
.small-ks-img {
    border-radius: 5px;
    width: auto !important;
    height: auto !important;
    max-height: 200px;
    max-width: 200px;
}
.ks-img-buttons-wrap {
    display: flex;
}
.ks-img-buttons {
    margin-right: 10px;
    display: flex;
    align-content: center;
    flex-direction: column;
    justify-content: space-evenly;
}
</style>
